export default "__VITE_ASSET__1bec2915__"